import QueryString from "query-string";
const { useLocation } = require("react-router");

export const useQueryParams = () => {
  const { search } = useLocation();
  return QueryString.parse(search);
};
